
    <ng-container [ngSwitch]="fontType">
      <p
        class="NativeElement"
        #content
        *ngSwitchCase="FontType.PARAGRAPH"
        [attr.data-text-transform]="textTransform"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-size-tablet]="sizeTablet"
        [attr.data-size-desktop]="sizeDesktop"
        [attr.data-weight]="weight"
        [attr.data-style]="style"
        [attr.data-line-break]="lineBreakEnabled"
        [flMarginRight]="isTruncatable ? Margin.XXSMALL : Margin.NONE"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </p>
      <span
        class="NativeElement"
        #content
        *ngSwitchCase="FontType.SPAN"
        [attr.data-text-transform]="textTransform"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-size-tablet]="sizeTablet"
        [attr.data-size-desktop]="sizeDesktop"
        [attr.data-weight]="weight"
        [attr.data-style]="style"
        [attr.data-line-break]="lineBreakEnabled"
        [flMarginRight]="isTruncatable ? Margin.XXSMALL : Margin.NONE"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </span>
      <strong
        class="NativeElement Strong"
        #content
        *ngSwitchCase="FontType.STRONG"
        [attr.data-text-transform]="textTransform"
        [attr.data-size]="size"
        [attr.data-size-tablet]="sizeTablet"
        [attr.data-size-desktop]="sizeDesktop"
        [attr.data-weight]="weight"
        [attr.data-line-break]="lineBreakEnabled"
        [flMarginRight]="isTruncatable ? Margin.XXSMALL : Margin.NONE"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </strong>
      <div
        class="NativeElement"
        #content
        *ngSwitchCase="FontType.CONTAINER"
        [attr.data-text-transform]="textTransform"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-size-tablet]="sizeTablet"
        [attr.data-size-desktop]="sizeDesktop"
        [attr.data-weight]="weight"
        [attr.data-line-break]="lineBreakEnabled"
        [flMarginRight]="isTruncatable ? Margin.XXSMALL : Margin.NONE"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </div>
      <ng-template #injectedContent> <ng-content></ng-content> </ng-template>
    </ng-container>
    <fl-link *ngIf="isTruncatable" (click)="toggleTruncatedText()">
      <ng-container *ngIf="isTruncated" i18n="Read more button">
        Read More
      </ng-container>
      <ng-container *ngIf="!isTruncated" i18n="Read less button">
        Read Less
      </ng-container>
    </fl-link>
  